/* src/app/features/player/components/player-compact-controls/player-compact-controls.component.scss */
::ng-deep .p-slider {
  height: 8px !important;
  background-color: var(--player_progress_bar_background) !important;
  border-radius: 4px;
  cursor: pointer;
}
::ng-deep .p-slider.p-slider-vertical {
  width: 8px !important;
}
::ng-deep {
}
::ng-deep .p-slider-range {
  background-color: var(--highlight_primary) !important;
}
::ng-deep {
}
::ng-deep .p-slider-handle {
  background-color: var(--highlight_primary) !important;
  border: 2px solid var(--player_progress_bar_background) !important;
}
::ng-deep {
}
::ng-deep .p-slider-handle:hover {
  box-shadow: 0 0 0 4px var(--highlight_primary_3);
}
:host {
  display: block;
  width: 100%;
  overflow: hidden;
}
.compact-controls-container {
  position: relative;
  padding: 35px 50px 50px 50px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow: hidden;
}
.cast-toggle {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
}
.background-img {
  position: absolute;
  filter: blur(48px);
  -webkit-filter: blur(48px);
  background-size: cover;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.info-section {
  display: flex;
  align-items: center;
  gap: 16px;
}
.info-section .logo-container {
  width: 120px;
  height: 80px;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-section .logo-container .item-logo {
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}
.info-section .track-info {
  text-align: start;
  gap: 5px;
  display: flex;
  flex-direction: column;
}
.info-section .track-info .title {
  font-size: 16px;
  font-weight: bold;
  color: var(--text_primary);
  margin: 0;
}
.info-section .track-info .subtitle {
  font-size: 14px;
  color: var(--text_secondary);
  margin: 0;
}
.progress-section {
  color: var(--text_primary);
}
.volume-container {
  position: relative;
  display: inline-block;
}
.volume-container .volume-component {
  position: absolute;
  right: 11px;
  bottom: 40px;
  z-index: 10;
  padding-bottom: 20px;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0.25s ease;
  cursor: default;
}
.volume-container .volume-component .slider-wrapper {
  padding: 15px 10px 15px 10px;
  background-color: var(--background_primary_8);
  border-radius: 15px;
}
.timeline-container {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}
.timeline-container .timeline {
  width: 100%;
}
.time {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 13px;
  color: var(--text_primary);
  font-size: 14px;
}
.volume-container:hover .volume-component {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
  pointer-events: auto;
}
.live-indicator {
  color: var(--text_primary);
  cursor: pointer;
}
/*# sourceMappingURL=player-compact-controls.component.css.map */
